/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import PartnerLogo from '@ion/dls/src/logo/PartnerLogo';
import useReseller from '@ion/dls/src/theme/resellers/useReseller';
import Logo from '@/components/logo/BMWLogo';
import styles from './DesktopHeader.module.scss';

/**
 * Provides the Application Header Logo Component when in Desktop Mode.
 */
export const DesktopHeaderLogo = () => {
  const {isReseller} = useReseller();
  if (!isReseller) {
    return (
      <div className={styles.logo} style={{flexGrow: 0.3}}>
        <Logo />
      </div>
    );
  }
  return <PartnerLogo isHeader />;
};

export default DesktopHeaderLogo;
